import React from 'react';
import { TabbedOverviewPage, SectionHeader } from '../components/OverviewSections.comp';
import { LearningImpactMethodologySection } from '../../DashboardCommon/LearningImpactMethodology.comp';
import PlanGate from '../components/PlanGate.comp';

// P1 + LC (dashboard catalog).
const MethodologyLearningImpactPage = () => (
    <PlanGate packages={['P1', 'LC']}>
        <TabbedOverviewPage
            skipNoDataGate
            tabs={[
                {
                    label: 'How Learning Impact Is Measured',
                    content: <LearningImpactMethodologySection SectionHeader={SectionHeader}/>,
                },
            ]}
        />
    </PlanGate>
);

export default MethodologyLearningImpactPage;
